// components/features/categories/CategoriesList.tsx
import { Category } from "@cabukaka/types";
import TableList, { SelectAction } from "../../ui/TableList";
import CategoryRow from "./CategoryRow";

interface CategoriesListProps {
  categories: Category[];
  onAction: (category: Category) => void;
  onSelectCategories?: (selectedCategories: Category[]) => void;
  selectable?: boolean;
  selectActions?: SelectAction[];
}

export default function CategoriesList({
  categories,
  onAction,
  onSelectCategories,
  selectable = false,
  selectActions
}: CategoriesListProps) {
  const columns = [
    { header: "Catégorie", className: "w-2/5" },
    { header: "Secteur", className: "hidden sm:table-cell w-1/5" },
    { header: "Produits", className: "hidden md:table-cell w-1/5" },
  ];

  return (
    <TableList
      items={categories}
      columns={columns}
      getId={(category) => category.id}
      onAction={onAction}
      onSelectItems={onSelectCategories}
      selectable={selectable}
      emptyMessage="Aucune catégorie trouvée"
      actionColumn={true}
      selectActions={selectActions}
      renderRow={(category, isSelected, onSelect) => (
        <CategoryRow
          key={category.id}
          category={category}
          onAction={onAction}
          onSelect={onSelect}
          isSelected={isSelected}
          selectable={selectable}
        />
      )}
    />
  );
}